import { AuditOutlined } from '@ant-design/icons'

export default function ReviewPage() {
    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <div className="page-header">
                <span className="color-white font-weight-700">投资审核</span>
            </div>
            <div className="page-content" style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ textAlign: 'center', color: 'var(--text-3)' }}>
                    <AuditOutlined style={{ fontSize: 48, marginBottom: 16, display: 'block', color: 'var(--text-4, #334155)' }} />
                    <div style={{ fontSize: 15, fontWeight: 600, color: 'var(--text-2)', marginBottom: 8 }}>投资审核</div>
                    <div style={{ fontSize: 13 }}>功能开发中，敬请期待</div>
                </div>
            </div>
        </div>
    )
}
